import React,{ useEffect, useState } from 'react'
import HeadNavBar from './headerNavbar'
import SideNavBar from './sideNavbar'
import { useNavigate ,useLocation} from 'react-router-dom';
import { message } from 'antd';



const CommonComponenent = () =>{

    const [loggedin, isLoggedin] = useState(false);

    const navigate = useNavigate()
    const location = useLocation();

    useEffect(() => {

        if(localStorage.getItem('token') === null || localStorage.getItem('token') === undefined || localStorage.getItem('token') === '' || localStorage.getItem('token') === 'undefined' || localStorage.getItem('token') === 'null' || localStorage.getItem('token') === ' '){

            message.error('Please login to continue')
            navigate('/')

        }

    },[])

    return(
            <>
                {/* <SideNavBar /> */}
                <div className='fixed-header'>
                {!location.pathname.includes("/questions") && !location.pathname.includes("/message") && <HeadNavBar />}

                </div>
            </>
    )
}

export default CommonComponenent